// extracted by mini-css-extract-plugin
export default {"ticker":"chyron_ticker__EOn7W"};